
import { actions, endpoints } from '../../../utils/constants';
import { CheckIfHasEmpty, Post, Get, Delete } from '../../../utils/functions';
import { put, all, takeEvery, select, call } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import { history } from '../../../config/redux-store';


import { Notification } from '../../components/index';

const formKeys = ['username', 'password'];

function* credentialsValue({ type, payload }) {
  const { id, value } = payload;
  yield put({ type: actions.SET_CREDENTIALS_VALUE, payload: { id, value } })
  const current = yield select(state => state.admin.form)
  yield put({ type: actions.SET_MODAL_BUTTON, payload: !CheckIfHasEmpty(current, formKeys) })
}



function* cancelCredentials() {
  yield history.goBack();
}

function* sendAndVerifyCredentials() {
  yield put({ type: actions.SET_IN_REQUEST, payload: true });
  const { username, password } = yield select(state => state.admin.form)
  if ((username && username !== '') && (password && password !== '')) {
    yield delay(3000);
    yield put({ type: actions.SET_IN_REQUEST, payload: false });
    yield put({ type: actions.SET_IS_ADMIN, payload: true })
  }
}

function* addUser({ payload }) {
  try {
    const header = yield getHeader()
    yield put({ type: actions.SET_IN_REQUEST, payload: true });
    const response = yield call(Post, endpoints.userCreate, payload, header)
    yield Notification('success', 'Sucesso', 'Usuário cadastrado!');
    yield put({ type: actions.CLEAR_COACH_FORM_VALUE });
  } catch ({ message }) {
    yield Notification('error', 'Ops!', message);
  } finally {
    yield put({ type: actions.SET_IN_REQUEST, payload: false });
  }
}

function* getListUsers() {
  try {
    const header = yield getHeader()
    yield put({ type: actions.SET_IN_REQUEST, payload: true });
    const { data } = yield call(Get, endpoints.listUsers, header)
    yield put({ type: actions.ADD_COACH, payload: data });
  } catch (error) {
    yield Notification('error', 'Ops!', 'Erro ao listar os usuários!');
  } finally {
    yield put({ type: actions.SET_IN_REQUEST, payload: false });
  }
}

function* removeUser({ payload }) {
  try {
    const header = yield getHeader()
    let { listCoachs } = yield select(state => state.admin)
    yield put({ type: actions.SET_IN_REQUEST, payload: true });
    const { status } = yield call(Delete, `${endpoints.removeUser}/${payload}`, header)
    if (status === 200) {
      const index = listCoachs.findIndex(item => item.id === payload)
      if (index > -1) {
        listCoachs.splice(index, 1)
      }
      yield put({ type: actions.ADD_COACH, payload: listCoachs });
      yield Notification('success', 'Sucesso!', 'Usuário removido com sucesso');
    }
  } catch (error) {
    yield Notification('error', 'Ops!', 'Erro ao remover o usuário!');
  } finally {
    yield put({ type: actions.SET_IN_REQUEST, payload: false });
  }

}

function* coachFormValue({ payload }) {
  const { id, value } = payload;
  yield put({ type: actions.SET_COACH_FORM_VALUE, payload: { id, value } })
}


function* goToEditUser({ payload }) {
  history.push(`/dashboard/admin/edit/${payload}`)
}

function* getUserById({ payload }) {
  try {
    yield put({ type: actions.SET_LOADING_USER, payload: true });
    const header = yield getHeader()
    const { data } = yield call(Get, `${endpoints.userInfo}/${payload}`, header)
    yield put({ type: actions.SET_COACH_FORM_VALUE_COMPLETE, payload: data })
  } catch (error) {
    yield Notification('error', 'Erro ao carregar usuário!', error.message);
  } finally {
    yield put({ type: actions.SET_LOADING_USER, payload: false });
  }

}

function* editUser({ payload }) {
  try {
    yield put({ type: actions.SET_IN_REQUEST, payload: true });
    const header = yield getHeader()
    const url = `${endpoints.userEdit}/${payload.id}`
    if (!payload.password) payload.password = null
    delete payload.id
    const { data } = yield call(Post, url, payload, header)
    yield Notification('success', 'Sucesso', 'Usuário alterado com sucesso');
  } catch (error) {
    yield Notification('error', 'Erro ao carregar usuário!', error.message);
  } finally {
    yield put({ type: actions.SET_IN_REQUEST, payload: false });
  }

}

function* goToAddUser() {
  yield put({ type: actions.CLEAR_COACH_FORM_VALUE });
  history.push('/dashboard/admin/add')
}

export function* getHeader() {
  const { token } = yield select(state => state.auth)
  return {
    'Authorization': `Bearer ${token}`
  }
}



export default function* AdminSaga() {
  yield all([
    yield takeEvery(actions.ASYNC_CREDENTIAL_VALUE, credentialsValue),
    yield takeEvery(actions.ASYNC_CANCEL_CREDENTIALS, cancelCredentials),
    yield takeEvery(actions.ADMIN_SEND_CREDENTIALS, sendAndVerifyCredentials),
    yield takeEvery(actions.ASYNC_ADD_COACH, addUser),
    yield takeEvery(actions.ASYNC_COACH_FORM_VALUE, coachFormValue),
    yield takeEvery(actions.ASYNC_GET_USERS, getListUsers),
    yield takeEvery(actions.ASYNC_REMOVE_USER, removeUser),
    yield takeEvery(actions.ASYNC_GO_TO_EDIT_USER, goToEditUser),
    yield takeEvery(actions.ASYNC_GO_TO_ADD_USER, goToAddUser),
    yield takeEvery(actions.ASYNC_GET_USER_BY_ID, getUserById),
    yield takeEvery(actions.ASYNC_EDIT_USER, editUser),
  ])
}


// WEBPACK FOOTER //
// ./src/App/containers/admin/admin.saga.js